<template>
  <div class="d-flex">
    <i :class="[`bi ${icon}`, 'me-2', `text-${color}`]"></i>
    <div>
      <span :class="['fw-500', 'small', `text-${color}`]">
        <slot></slot>
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InfoItem',
  props: {
    color: {
      type: String,
      default: 'text',
      validator: (value) => ['text', 'danger', 'success', 'info', 'warning'].includes(value)
    },
    icon: {
      type: String,
      required: true
    }
  }
}
</script>
